import Layout from "@/components/Layout";
import Metadata from "@/components/Metadata";
import HeroSection from "@/components/OurProcess/Hero/Hero";
import React from "react";
import { createClient } from "../../prismicio";
import HowItWorksSection from "@/components/OurProcess/HowItWorks/HowItWorksSection";
import TestimonialsSection from "@/components/OurProcess/Testimonials/TestimonialsSection";
import FAQSection from "@/components/OurProcess/FAQs/FAQSection";

const OurProcessPage = ({ page, globals, ourProcessPageData }) => {
  //   const pageData = ourProcessPageData?.data;
  const commonComponents = globals?.data;
  const pageData = ourProcessPageData.data;

  return (
    <Layout data={commonComponents}>
      <Metadata
        title={pageData?.metadata_title}
        description={pageData?.metadata_desc}
        image={pageData?.metadata_image.url}
        path="/"
      />
      {/* <div className={s.section_wrapper}> */}
      <HeroSection data={pageData} />
      <HowItWorksSection data={pageData} />
      <TestimonialsSection data={pageData} />
      <FAQSection data={pageData} />
      {/* </div> */}
    </Layout>
  );
};

export default OurProcessPage;

export async function getStaticProps({ previewData }) {
  const client = createClient({ previewData });

  const page = await client.getSingle("homepage");
  const globals = await client.getSingle("globals");
  const blogs = await client.getAllByType("blog_individual_page");
  const ourProcessPageData = await client.getSingle("our_process_page");

  return {
    props: {
      page,
      globals,
      blogs: blogs.slice(0, 3).map(({ uid, data }) => {
        const { title, image, excerpt } = data;
        return {
          uid,
          data: {
            title,
            image,
            excerpt,
          },
        };
      }),
      ourProcessPageData,
    },
  };
}
